module.exports = __webpack_public_path__ + "img/001-Hombre.bdd9aaee.png";